import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

const initialState = {
    loading: false,
    franchise: [],
    error: ''
}

const url = `${BASE_URL}/franchise`

const token = localStorage.getItem("token")

const config = {
    headers: {
        Authorization: `Token ${token}`,
    }
}


export const fetchFranchise= createAsyncThunk(
    'fetch/franchise', async () => {
        return axios
        .get(`${url}/`, config)
        .then((response) => response.data)
    }
)
 

const franchiseSlice = createSlice({
    name: "franchise",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(fetchFranchise.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(fetchFranchise.fulfilled, (state, action) => {
        state.loading = false;
        state.franchise = action.payload;
        state.error = "";
      });
      builder.addCase(fetchFranchise.rejected, (state, action) => {
        state.loading = false;
        state.franchise = [];
        state.error = action.error;
      });
    },
  });
  


export default franchiseSlice.reducer


 
